import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, isDevMode } from '@angular/core';
import { GenericAuthService, GENERIC_AUTH_SERVICE_TOKEN } from '@nk/auth-lib';
import { AppEnvConfig, APP_ENV_CONFIG_TOKEN, getStrippedHostname } from '@nk/utils-lib';
import { ApiClientBase } from './api-client-base.service';
import { AuthConfig } from '@auth0/auth0-angular';

type AdminAppEnvConfig = AppEnvConfig & {
  auth: AuthConfig;
};

@Injectable()
export class AdminApiClient extends ApiClientBase {
  constructor(
    protected override http: HttpClient,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) protected override authService: GenericAuthService,
    @Inject(APP_ENV_CONFIG_TOKEN) private _appEnvConfig: AdminAppEnvConfig,
  ) {
    super(http, authService);
    this.rootUrl =
      (this._appEnvConfig &&
        this._appEnvConfig.apiRootUrls &&
        this._appEnvConfig.apiRootUrls[this._appEnvConfig.environmentKey]) ??
      '';

    if (this._appEnvConfig.environmentKey === 'local') {
      if (!isDevMode) {
        console.error('! Application environment is set as develop, but isDevMode is not True');
      }
      this.rootUrl = 'http://localhost:15011/';
    } else {
      if (!this.rootUrl) {
        console.warn('! No environment set.', this._appEnvConfig);
      }
      const strippedHostname = getStrippedHostname();
      this.rootUrl = `https://admin.${strippedHostname}/api/`;
    }
  }
}
